import { OmniVisibleRow } from '../omnidashboard.models';

function normalizeViewLabel(viewLabel: string): string {
  let normalized = '';
  let lastWasHyphen = false;

  for (let i = 0; i < viewLabel.length; i++) {
    const ch = viewLabel.charAt(i);
    const isAlphaNumeric =
      (ch >= 'A' && ch <= 'Z') ||
      (ch >= 'a' && ch <= 'z') ||
      (ch >= '0' && ch <= '9');

    if (isAlphaNumeric) {
      normalized += ch;
      lastWasHyphen = false;
      continue;
    }

    if (!lastWasHyphen) {
      normalized += '-';
      lastWasHyphen = true;
    }
  }

  let start = 0;
  while (start < normalized.length && normalized.charAt(start) === '-') {
    start++;
  }

  let end = normalized.length;
  while (end > start && normalized.charAt(end - 1) === '-') {
    end--;
  }

  return normalized.slice(start, end);
}

export function buildOmniExportRows(
  visibleRows: OmniVisibleRow[],
  ergSiteHeader: string,
  metricKey: string
): Array<Record<string, string>> {
  return visibleRows.map((visibleRow) => {
    const row: Record<string, string> = { [ergSiteHeader]: visibleRow.erg.bpgName };
    visibleRow.cells.forEach((item) => {
      row[item.site.siteName] = item.cell.metrics.get(metricKey).value || item.resolved.displayValue;
      if (row[item.site.siteName] === 'N/A') {
        row[item.site.siteName] = '-';
      }
    });
    return row;
  });
}

export function buildOmniExportFileBaseName(
  viewLabel: string,
  fiscalYear: string,
  isFilterActive: boolean,
  now?: Date
): string {
  const fiscalYearSuffix = fiscalYear ? fiscalYear.slice(-2) : '';
  const normalizedView = viewLabel
    ? normalizeViewLabel(viewLabel)
    : 'View';
  const fiscalYearPart = fiscalYearSuffix ? 'FY' + fiscalYearSuffix : 'FY';
  const filteredSuffix = isFilterActive ? '_filtered' : '';
  const timestamp = (now || new Date()).toISOString().slice(0, 10);
  return 'Omnidashboard_' + fiscalYearPart + '_' + normalizedView + filteredSuffix + '_' + timestamp;
}
